import { useLocaleContext } from '../../i18n';
import BaseSlider from './BaseSlider';

interface Props {
  value: number;
  onChange: (value: number) => void;
  zoneColor?: string;
  disabled?: boolean;
}

export default function BikeWeightSlider({ value, onChange, disabled, zoneColor }: Props) {
  const { locale } = useLocaleContext();

  return (
    <BaseSlider
      label={locale.settings.bike.weight}
      value={value}
      onChange={onChange}
      min={4}
      max={50}
      step={0.5}
      unit="kg"
      disabled={disabled}
      zoneColor={zoneColor}
      formatValue={(v) => v.toFixed(1)}
    />
  );
}
